import styled from 'styled-components'

export const UserIcon = styled.div`
  height: 25px;
  width: 25px;
  background-color: #3f51b5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  bottom: 5px;
`

export const CardInfo = styled.div`
  margin: 10px 10px 10px 0px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`

export const DateInfo = styled.div`
  font-style: italic;
  font-size: 10px;
`

export const CycleTime = styled.div`
  height: 50px;
  border-radius: 5px;
  padding: 15px;
  margin: 10px 0px;
  border: 1px solid rgba(0, 0, 0, 0.12);
`
export const Content = styled.div`
  margin: 10px 0px;
  p {
    margin-bottom: 0;
  }
  table img {
    max-width: 100% !important;
    height: auto !important;
  }
  .ql-editor {
    height: auto !important;
    min-height: auto !important;
    max-height: unset !important;
    counter-reset: unset !important;
    line-height: unset !important;
    outline: none !important;
    overflow-y: unset !important;
    padding: 0px !important;
    tab-size: unset !important;
    text-align: unset !important;
    white-space: unset !important;
    word-wrap: unset !important;
    resize: unset !important;
  }
`